import { Link, useLocation } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-50 font-sans flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 lg:px-8 pt-40 pb-24 relative overflow-hidden">
        <div className="pointer-events-none absolute -right-24 top-20 h-96 w-96 rounded-full bg-primary-500/10 blur-3xl"></div>
        <div className="relative z-10 max-w-2xl text-center">
          <p className="font-display text-7xl sm:text-9xl font-extrabold text-primary-500/25 leading-none">404</p>
          <h1 className="mt-6 font-display text-3xl sm:text-4xl font-bold uppercase tracking-tight text-foreground-50">
            Diese Seite <span className="text-primary-500">existiert nicht</span>
          </h1>
          <p className="mt-4 text-foreground-400">
            Die aufgerufene Adresse konnte nicht gefunden werden.
          </p>
          <p className="mt-2 text-sm text-foreground-600 font-mono break-all">{location.pathname}</p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center h-12 px-8 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold cursor-pointer whitespace-nowrap transition-colors"
            >
              Zurück zur Startseite
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center h-12 px-8 rounded-md border border-background-300 text-foreground-50 hover:bg-background-100 font-semibold cursor-pointer whitespace-nowrap transition-colors"
            >
              Kontakt aufnehmen
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}